import React, { FC } from 'react'
import { useWatch } from 'react-hook-form'
import PhoneIcon from 'transfix-icons/build/PhoneIcon'
import formatPhone from 'utils/formatPhone'

interface IDriverPhoneRenderProps {
  phone?: string | null
  driverId?: number
}

// Display driver's phone number when currently selected driver id matches initial id
const DriverPhoneRender: FC<IDriverPhoneRenderProps> = ({ driverId, phone }) => {
  const driverIdVal = useWatch({
    name: 'driverId',
  })
  return (
    <>
      {phone && driverIdVal === driverId && (
        <>
          <PhoneIcon className='db mr2' />
          <a href={`tel:+${phone}`} aria-label={`${phone}`}>
            {formatPhone(phone)}
          </a>
        </>
      )}
    </>
  )
}

export default DriverPhoneRender
